import { animationTransition } from '@shared/utils/animationTransition';
import { Box, css, styled } from '@withjoy/joykit';

/**
 * Hide children during loading while keeping the container visible with its background.
 * This prevents a white flash during component transitions (e.g., skeleton → content)
 * by ensuring the themed background remains visible even when content is loading.
 */
const hideOnLoading = () => css`
  > * {
    visibility: hidden;
    opacity: 0;
  }
`;

const showOnLoading = () => css`
  visibility: initial;
  transition: ${animationTransition('opacity', 'background', 'background-color')};
`;

export const StyledBoxBrannan = styled(Box)<{
  loading: boolean;
  isPreviewing: boolean;
  customBackgroundColor?: string;
  loadingBackgroundColor?: string;
  customTextColor?: string;
}>`
  pointer-events: ${({ isPreviewing }) => (isPreviewing ? 'none' : 'all')};
  /* This overflow is necessary to prevent the outer frame from scrolling horizontally when the artwork is too wide */
  overflow-x: clip;
  ${({ loading }) => (loading ? hideOnLoading : showOnLoading)};
  ${props =>
    props.customBackgroundColor &&
    css`
      background-color: ${props.customBackgroundColor} !important;
    `}
  ${props =>
    /* Use loadingBackgroundColor as fallback during loading when customBackgroundColor isn't set */
    props.loading &&
    !props.customBackgroundColor &&
    props.loadingBackgroundColor &&
    css`
      background-color: ${props.loadingBackgroundColor};
    `}
  ${props =>
    props.customTextColor &&
    css`
      color: ${props.customTextColor} !important;
    `}
`;
